import { defineModule } from '../../manifest.js';
/**
 * Platform Core — mandatory, unsellable, never a SKU (C-1, §2.1).
 *
 * It appears in the registry so that every enforcement point resolves through
 * one list rather than special-casing a string. `sellable: false` is what makes
 * it unsellable; the entitlement guard exempts it by key, and a test asserts
 * that no entitlement record can be created for it.
 */
export const manifest = defineModule({
    moduleKey: 'platform',
    name: 'Platform Core',
    description: 'Tenancy, hierarchy, identity, authorisation, audit, entitlements and the shared kernel. ' +
        'Provisioned with every tenant and never disabled.',
    kind: 'core',
    sellable: false,
    navigationModuleKey: 'administration',
    editions: [],
    features: [],
    limitTypes: [],
    meteredEvents: [
        // Platform Core meters what the PLATFORM does. A SKU's own usage is
        // declared by that SKU's manifest, prefixed with its own key, so a usage
        // figure is always attributable to the module it belongs to — which is the
        // question an invoice dispute turns on.
        //
        // Note on C-3: this is the PLATFORM-WIDE active-user count. A per-module
        // active-user cap needs the module to record its own activity, because
        // "active in Finance" is a fact only Finance can assert. Deferred with the
        // module, not approximated here.
        {
            key: 'platform.user.active',
            description: 'A person did something interactive. One row per user per day.',
            unit: 'active_user',
        },
        {
            key: 'platform.attachment.stored',
            description: 'Bytes promoted out of quarantine and held in primary storage.',
            unit: 'byte',
        },
        {
            key: 'platform.notification.sent',
            description: 'A notification delivered on a channel that costs something to use.',
            unit: 'count',
        },
        // ---- Stage 7: the AI gateway ------------------------------------------
        // ON PLATFORM CORE, NOT ON `ai-automation`, and that is the same C-2
        // argument the Stage 7 permissions make. The gateway is mandatory shared
        // Core: every module routes through it and none may reach a provider
        // directly. If its usage were metered against the add-on, a tenant without
        // the add-on would generate untracked cost — and the first module wanting a
        // summary would be pushed toward calling a provider itself, which is the
        // one outcome the whole design exists to prevent.
        {
            key: 'platform.ai.request',
            description: 'A completed trip through the AI gateway. Refusals are not billable.',
            unit: 'count',
        },
        // TOKENS ARE METERED AS `count`, AND THE REASON IS A SCHEMA CONSTRAINT
        // RATHER THAN A PREFERENCE. `usage_activity.unit` has carried the CHECK
        // ('count','active_user','byte','second') since 0026, and adding a `token`
        // member is a destructive change to a constraint on a partitioned table
        // holding live data. A token IS a count of things, the quantity is exact
        // either way, and the metric key already says what is being counted — so
        // the honest unit costs nothing and the migration would cost an outage.
        {
            key: 'platform.ai.tokens_input',
            description: 'Input tokens a completed gateway call consumed, as counted by the provider.',
            unit: 'count',
        },
        {
            key: 'platform.ai.tokens_output',
            description: 'Output tokens a completed gateway call produced, as counted by the provider.',
            unit: 'count',
        },
    ],
    requiredCore: [],
    optionalModules: [],
    integrationDeps: [],
    lifecycle: 'available',
    commercialRelease: 'phase_1',
    version: 1,
});
//# sourceMappingURL=module.manifest.js.map